import moment from 'moment';

const formatDate = date => {
  return moment(date).format().split('T')[0];
};

export default formatDate;
